import axios from "axios";

export async function exportExcelCadastro() {
  const excelUrl = "/portal/rest/contador/report/obrigacao/cadastro";

  try {
    const response = await axios.get(excelUrl, {
      withCredentials: true,
      responseType: "blob", // necessário para baixar arquivo
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "cadastro-obrigacao.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // remove depois do clique
  } catch (error) {
    console.error("Erro ao exportar os dados:", error);
    throw error; // deixa o componente decidir o que fazer
  }
}

export async function exportTarefasExcel({
  report,
  diaVencimento = "",
  dataVencimento = "",
  nome = "",
  clienteId = "",
  categoriaId = "",
}) {
  const excelUrl = "/portal/rest/contador/obrigacao/tarefa/export/excel";
  const params = {
    report,
    diaVencimento,
    dataVencimento,
    nome,
    clienteId,
    categoriaId,
  };

  try {
    const response = await axios.get(excelUrl, {
      params,
      withCredentials: true,
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");

    let fileName = "tarefas.xlsx"; // default
    switch (report) {
      case "0":
        fileName = "planilha-controle.xlsx";
        break;
      case "1":
        fileName = "tarefas-resumido.xlsx";
        break;
      case "2":
        fileName = "tarefas-detalhado.xlsx";
        break;
      case "9":
        fileName = "tarefas-inconsistentes.xlsx";
        break;
      case "12":
        fileName = "dados-tarefas-detalhado.xlsx";
        break;
    }

    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Erro ao exportar os dados:", error);
    throw error; // deixa o componente decidir se mostra toast/alert
  }
}
